export default class Menu {
  boundToggleMenu: (e: Event) => void;
  boundToggleSubMenu: (e: Event) => void;

  nav: HTMLDivElement | null;
  menuIcon: HTMLButtonElement | null;
  subMenuElems: NodeListOf<HTMLLIElement>;
  subMenuElemsLength: number;
  subMenuLinks: NodeListOf<HTMLAnchorElement>;
  subMenuLinksLength: number;

  /**
   * Set scope, bind functions and get elements
   */
  constructor(scope: HTMLBodyElement) {
    // This binding is necessary to make `this` work in the callback
    this.boundToggleMenu = (e) => this.toggleMenu(e);
    this.boundToggleSubMenu = (e) => this.toggleSubMenu(e);

    // Get necessary elements
    this.nav = scope.querySelector(".header__navigation");
    this.menuIcon = scope.querySelector(".header__navToggle");
    this.subMenuElems = scope.querySelectorAll(
      ".header__navigation .menu-item",
    );
    this.subMenuElemsLength = this.subMenuElems.length;
    this.subMenuLinks = scope.querySelectorAll(".js-navigation-addClass");
    this.subMenuLinksLength = this.subMenuLinks.length;
  }

  /**
   * Bind all event listeners to appropiate elemens
   */
  init() {
    // Toggle menu on hamburger icon click
    if (this.menuIcon) {
      this.menuIcon.addEventListener("click", this.boundToggleMenu, false);
    }

    for (let i = 0; i < this.subMenuLinksLength; i += 1) {
      const elem = this.subMenuLinks[i];

      elem.addEventListener("click", this.boundToggleSubMenu, false);
    }
  }

  /**
   * Show or hide the overlay menu
   */
  toggleMenu(e: Event) {
    e.preventDefault();

    this.menuIcon?.classList.toggle("-open");
    this.nav?.classList.toggle("-open");
  }

  /**
   * Show or hide a submenu
   */
  toggleSubMenu(e: Event) {
    e.preventDefault();

    this.removeOpenClass();

    const target = e.currentTarget as HTMLAnchorElement;
    target.classList.add("-open");
    target.parentElement?.classList.add("-open");
  }

  removeOpenClass() {
    for (let i = 0; i < this.subMenuElemsLength; i += 1) {
      const elem = this.subMenuElems[i];

      elem.classList.remove("-open");
    }

    for (let i = 0; i < this.subMenuLinksLength; i += 1) {
      const elem = this.subMenuLinks[i];

      elem.classList.remove("-open");
    }
  }
}
